import { COLORS } from 'helpers/globals'

export default {
  warningWrapper: {
    display: 'inline-block !important',
    color: COLORS.warning,
    marginLeft: '.5rem',
    '&:hover': {
      cursor: 'pointer'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Wire/DistanceWarning/style.js